module.exports = __webpack_public_path__ + "img/user_name_icon.38d0a2ad.svg";